import { useEffect, useRef } from "react";

export function PasskeyInput({
  value,
  onChange,
  disabled,
  label,
}: {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  label: string;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const digits = value.padEnd(4, " ").slice(0, 4).split("");

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <label className="passkey-field">
      <span>{label}</span>
      <div className="passkey-shell" onClick={() => inputRef.current?.focus()}>
        {digits.map((digit, index) => (
          <span
            className={`passkey-digit ${digit.trim() ? "filled" : ""}`}
            style={{ transitionDelay: `${index * 42}ms` }}
            key={index}
          >
            {digit.trim() ? "•" : ""}
          </span>
        ))}
        <input
          ref={inputRef}
          value={value}
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={4}
          disabled={disabled}
          aria-label={label}
          onChange={(event) =>
            onChange(event.target.value.replace(/\D/g, "").slice(0, 4))
          }
        />
      </div>
    </label>
  );
}
